<template>
    <section>
        <ds-modal
            :is-open="isOpen"
            :title="modalContent.TITLE"
            data-qa="access-privileges-modal"
            show-close
            @close="close"
        >
            <template #header>
                <ds-button
                    data-qa="add-privilege-button"
                    @click="addUserOrGroupPrivilege"
                >
                    Add
                </ds-button>
            </template>

            <template #default>
                <div>
                    <ds-multiselect
                        v-model="selectedUserOrGroup"
                        class="multi-select-field"
                        bind-value-only
                        :placeholder="modalContent.SELECT"
                        :options="userOrGroupOptions"
                        required
                        :submitted="submitted"
                        searchable
                    />

                    <ds-multiselect
                        v-model="selectedUserOrGroupMode"
                        class="multi-select-field"
                        bind-value-only
                        :placeholder="modalContent.PERMISSION"
                        :options="accessModes"
                        required
                        :submitted="submitted"
                        searchable
                    />
                </div>
            </template>
        </ds-modal>
    </section>
</template>

<script>
export default {
    props: {
        userOrGroupOptions: Array,
        modalContent: Object,
        addPrivilege: {
            type: Function,
            default: async () => {},
        },
    },

    data() {
        return {
            accessModes: [
                { value: '1', label: 'View this contact record' },
                { value: '2', label: 'View and edit this contact record' },
            ],
            submitted: false,
            selectedUserOrGroup: '',
            selectedUserOrGroupMode: '',
            isOpen: false,
        };
    },

    methods: {
        open() {
            this.isOpen = true;
        },

        close() {
            this.submitted = false;
            this.selectedUserOrGroup = '';
            this.selectedUserOrGroupMode = '';
            this.isOpen = false;
        },

        addUserOrGroupPrivilege() {
            this.submitted = true;

            if (this.selectedUserOrGroup && this.selectedUserOrGroupMode) {
                this.addPrivilege(this.selectedUserOrGroup, this.selectedUserOrGroupMode);
                this.$toast({ message: 'Added new permission' });
                this.close();
            }
        },
    },
};
</script>
